// extracted by mini-css-extract-plugin
export default {"wrapper":"UiCardList_wrapper","disabled":"UiCardList_disabled","header":"UiCardList_header","list":"UiCardList_list","highlight":"UiCardList_highlight"};